import Raven from 'raven-js';
import { createAsyncLocalSuperstore } from 'superstore';
const getStore = () => {
  let storeInstance;
  try {
    storeInstance = createAsyncLocalSuperstore({
      namespace: 'Ai Addon Copilot Preview'
    });
  } catch (error) {
    if (error instanceof Error) {
      Raven.captureException(error, {
        level: 'warning'
      });
    }
  }
  return storeInstance;
};
export const localSuperstore = getStore();